// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3838":"css/admin-app.6770","9739":"css/app.6770"}[chunkId] + ".css";
};